import {
  Button,
  Box,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const AdditionalItemsForm = ({ mainForm, entries, setEntries }) => {
  const handleFieldChange = (indexOfEntry, event) => {
    const { name, value } = event.target;
    setEntries(prevEntries => {
      const updatedEntries = [...prevEntries];
      updatedEntries[indexOfEntry] = {
        ...updatedEntries[indexOfEntry],
        [name]: value,
      };
      return updatedEntries;
    });
  };

  const handleAddEntry = () => {
    setEntries(prevEntries => [
      ...prevEntries,
      {
        id: prevEntries.length + 1,
        gameName: '',
        gameNumber: '',
        packNumber: '',
        beginning: '',
        ending: '',
        packStatus: '',
      },
    ]);
  };

  const handleDeleteRow = indexToRemove => {
    setEntries(prevEntries =>
      prevEntries.filter((_, index) => index !== indexToRemove)
    );
  };

  return (
    <Box>
      {entries.length < 25 && (
        <Button
          variant='contained'
          sx={{
            marginRight: '10px',
            backgroundColor: 'var(--procyon-green)',
            color: '#000000',
            fontFamily: 'BrightstarSans-Regular',
            marginBottom: '10px',
          }}
          onClick={handleAddEntry}
        >
          + Additional Item
        </Button>
      )}
      <TableContainer
        component={Paper}
        sx={{ marginTop: '20px', width: { xs: 'auto', md: 'var(--forms-layout-width, 90vw)' } }}
      >
        <Table aria-label='stolen duplicated fields table'>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell
                align='center'
                sx={{
                  fontFamily: 'BrightstarSans-Bold',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
              >
                ID
              </TableCell>
              <TableCell
                align='center'
                sx={{
                  fontFamily: 'BrightstarSans-Bold',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
              >
                Game Name
              </TableCell>
              <TableCell
                align='center'
                sx={{
                  fontFamily: 'BrightstarSans-Bold',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
              >
                Game Number
              </TableCell>
              <TableCell
                align='center'
                sx={{
                  fontFamily: 'BrightstarSans-Bold',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
              >
                Pack Number
              </TableCell>
              <TableCell
                align='center'
                sx={{
                  fontFamily: 'BrightstarSans-Bold',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
              >
                Beginning
              </TableCell>
              <TableCell
                align='center'
                sx={{
                  fontFamily: 'BrightstarSans-Bold',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
              >
                Ending
              </TableCell>
              {mainForm.jurisdiction === 'New York' && (
                <TableCell
                  align='center'
                  sx={{
                    fontFamily: 'BrightstarSans-Bold',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                  }}
                >
                  Pack Status
                </TableCell>
              )}
              {entries.length > 1 && (
                <TableCell
                  align='center'
                  sx={{
                    textAlign: 'center',
                    verticalAlign: 'middle',
                    fontFamily: 'BrightstarSans-Bold',
                  }}
                >
                  Actions
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {entries.map((field, index) => (
              <TableRow
                key={field.id}
                sx={{
                  '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                }}
              >
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <TextField
                    name='gameName'
                    value={field.gameName}
                    onChange={e => handleFieldChange(index, e)}
                    size='small'
                    fullWidth
                    inputProps={{ style: { textAlign: 'center' } }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    name='gameNumber'
                    value={field.gameNumber}
                    onChange={e => handleFieldChange(index, e)}
                    size='small'
                    fullWidth
                    inputProps={{ style: { textAlign: 'center' } }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    name='packNumber'
                    value={field.packNumber}
                    onChange={e => handleFieldChange(index, e)}
                    size='small'
                    fullWidth
                    inputProps={{ style: { textAlign: 'center' } }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    name='beginning'
                    value={field.beginning}
                    onChange={e => handleFieldChange(index, e)}
                    size='small'
                    fullWidth
                    inputProps={{ style: { textAlign: 'center' } }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    name='ending'
                    value={field.ending}
                    onChange={e => handleFieldChange(index, e)}
                    size='small'
                    fullWidth
                    inputProps={{ style: { textAlign: 'center' } }}
                  />
                </TableCell>
                {mainForm.jurisdiction === 'New York' && (
                  <TableCell>
                    <FormControl fullWidth size='small'>
                      <Select
                        name='packStatus'
                        value={field.packStatus}
                        onChange={e => handleFieldChange(index, e)}
                        displayEmpty
                        inputProps={{ style: { textAlign: 'center' } }}
                      >
                        <MenuItem value='Activated'>Activated</MenuItem>
                        <MenuItem value='Confirmed'>Confirmed</MenuItem>
                        <MenuItem value='Settled'>Settled</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                )}
                {entries.length > 1 && (
                  <TableCell>
                    <Button
                      onClick={() => handleDeleteRow(index)}
                      color='error'
                      variant='outlined'
                      size='small'
                      sx={{ fontFamily: 'BrightstarSans-Regular' }}
                    >
                      Delete
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AdditionalItemsForm;
